module.exports = __webpack_public_path__ + "static/media/on_prem_workflow.76114f7f.png";